"use strict";

exports.__esModule = true;
exports.fareFamilyItineraryFactory = fareFamilyItineraryFactory;
function fareFamilyItineraryFactory(itinerary) {
  var _itinerary$firstLeg, _itinerary$firstLeg$s, _itinerary$firstLeg$s2;
  return {
    id: itinerary === null || itinerary === void 0 ? void 0 : itinerary.id,
    code: itinerary === null || itinerary === void 0 ? void 0 : (_itinerary$firstLeg = itinerary.firstLeg) === null || _itinerary$firstLeg === void 0 ? void 0 : (_itinerary$firstLeg$s = _itinerary$firstLeg.segments) === null || _itinerary$firstLeg$s === void 0 ? void 0 : (_itinerary$firstLeg$s2 = _itinerary$firstLeg$s[0]) === null || _itinerary$firstLeg$s2 === void 0 ? void 0 : _itinerary$firstLeg$s2.fareFamily,
    totalPrice: itinerary === null || itinerary === void 0 ? void 0 : itinerary.totalPrice,
    displayPrice: itinerary === null || itinerary === void 0 ? void 0 : itinerary.displayPrice,
    cid: itinerary === null || itinerary === void 0 ? void 0 : itinerary.cid,
    cheapestRoundtripTotal: itinerary === null || itinerary === void 0 ? void 0 : itinerary.cheapestRoundtripTotal
  };
}